import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Set Content-Type appropriately (cookies handle auth automatically)
API.interceptors.request.use((config) => {
  // Let axios auto-set Content-Type for FormData (multipart uploads)
  // Only set application/json for non-FormData requests
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

export default API;
export { BACKEND_URL };
